import { Component, Inject, ViewChild, TemplateRef, Input, ChangeDetectorRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { MatDatepicker, MatDatepickerToggle } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { MatTableDataSource } from '@angular/material/table';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Observable, Subject } from 'rxjs';
import { finalize, switchMap, takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/services/AuthenticationService'
import { ICompany } from '@app/core/interfaces/ICompany';
import { IFile } from '@app/core/interfaces/IFile';
import { CompanyService } from '@app/core/services/CompanyService';
import { InvoiceService } from '@app/core/services/InvoiceService';
import { UserService } from '@app/core/services/UserService';
import { FileService } from '@app/core/services/FileService';
import { EditCustomerDialogComponent } from '../../shared/customer/EditCustomerDialog.Component';
import { IFileType } from '@app/core/interfaces/IFileType';
import { IDeduction } from '@app/core/interfaces/invoice/IDeduction';



@Component({
  standalone: false,
  selector: 'invoice-admin-dialog',
  templateUrl: 'invoice-admin.Dialog.Component.html'
})


export class InvoiceAdminDialogComponent {
  private readonly invoiceItemGroupType = 'InvoiceItem';
  private readonly workedHoursGroupType = 'WorkedHours';
  public isLoading: boolean = true;
  public invoiceReady = false;
  public loadError = false;
  private readonly destroyed$ = new Subject<void>();
  private _dimesionToggle = false;
  private _formValid = false;
  public _imageList: any[] = [];
  public _hasImages = false;
  private _showImageList = false;
  private _showAttachments = false;
  private _hasAttachments = false;
  private _showComments = false;
  public customer: ICompany;
  public isNewCustomer: boolean;
  @ViewChild('myInput', { static: false })
  myInputVariable: any;
  private _apiBaseUrl: string;
  private hoursList = [];
  private vatList = [];
  private rowTypeList = [];
  private hoursSelected: string = "8";
  private vatSelected: string = "25";
  private rowTypeSelected: string = "0"
  private row: any = {};
  public sendTypes: any = [{ Id: 1, Name: "E-post" }, { Id: 2, Name: "Post" }, { Id: 3, Name: "E-faktura" }];
  EnrollmentDate = null;
  downloading = false;
  activePdfReport: string | null = null;
  completedPdfReport: string | null = null;
  ExpressPayout: boolean;
  file: IFile = { Id: 0, FileType: { Id: 0, Name: null, TechnicalName: null, PublicToMembers: false }, FileSize: 0, Name: null, Guid: null, Url: null, DisplayDate: null };
  filter: string;
  search: '';
  asc: boolean = false;
  orderBy: string = 'Created';
  documents: any;
  fileTypes = [] as Array<IFileType>;
  dataSource: MatTableDataSource<Array<IFile>>;
  sumDomesticAllowance: number = 0;
  sumInternationalAllowance: number = 0;
  sumMileage: number = 0;
  mileageDistance: number = 0;
  sendDocumentByEmailValid: boolean = false;
  sendDocumentByEmailErrorMessage: string = '';
  DeductionsTotal: number = 0;
  UnhandledDeductions: boolean = false;
  hasActiveWageGarnishment: boolean = false;
  hasUnhandledGarnishableDeductions: boolean = false;
  isInvoiceSent = false;
  organizationSender: boolean = false;
  ContactEmailApprovedForExpress = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<InvoiceAdminDialogComponent>,
    private authenticationService: AuthenticationService,
    private invoiceService: InvoiceService,
    private companyService: CompanyService,
    public dialog: MatDialog,
    private userService: UserService,
    private fileService: FileService,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  private setLoading(value: boolean): void {
    if (this.isLoading === value) {
      return;
    }

    Promise.resolve().then(() => {
      this.isLoading = value;
      this.changeDetectorRef.markForCheck();
    });
  }

  // Calculates total worked hours for a group in decimal form (e.g., 1,5 h)
  getGroupTotalHoursDecimal(group: any) {
    const totalMinutes = this.getGroupTotalMinutes(group);
    if (totalMinutes <= 0) {
      return '0 h';
    }

    const decimalHours = totalMinutes / 60;
    // Up to 2 decimals, trim trailing zeros, use comma as decimal separator
    let formatted = decimalHours.toFixed(2).replace(/\.?0+$/, '');
    formatted = formatted.replace('.', ',');

    return formatted + ' h';
  }

  // Calculates the average hourly rate for a group (amount divided by decimal hours)
  getGroupAverageHourlyRate(group: any): number {
    const totalMinutes = this.getGroupTotalMinutes(group);
    const decimalHours = totalMinutes / 60;
    if (decimalHours <= 0) {
      return 0;
    }

    const amount = this.getAverageHourlyRateAmount(group);
    return amount / decimalHours;
  }

  // Calculates total worked hours for the entire invoice (all groups) in decimal form
  getInvoiceTotalHoursDecimal() {
    if (!this.data || !this.data.InvoiceGroups || this.data.InvoiceGroups.length === 0) {
      return '0 h';
    }

    let totalMinutes = 0;
    for (let g = 0; g < this.data.InvoiceGroups.length; g++) {
      const group = this.data.InvoiceGroups[g];
      if (!group || !group.InvoiceRows) { continue; }
      for (let i = 0; i < group.InvoiceRows.length; i++) {
        const row = group.InvoiceRows[i] || {};
        const hours = parseInt(row.HoursWorked, 10) || 0;
        const minutes = parseInt(row.MinutesWorked, 10) || 0;
        totalMinutes += hours * 60 + minutes;
      }
    }

    const decimalHours = totalMinutes / 60;
    let formatted = decimalHours.toFixed(2).replace(/\.?0+$/, '');
    formatted = formatted.replace('.', ',');
    return formatted + ' h';
  }

  hasInvoiceGroupType(group: any): boolean {
    return typeof group?.Type?.TechnicalName === 'string' && group.Type.TechnicalName.trim() !== '';
  }

  isWorkedHoursGroup(group: any): boolean {
    return typeof group?.Type?.TechnicalName === 'string'
      && group.Type.TechnicalName.trim().toLowerCase() === this.workedHoursGroupType.toLowerCase();
  }

  isInvoiceItemGroup(group: any): boolean {
    return typeof group?.Type?.TechnicalName === 'string'
      && group.Type.TechnicalName.trim().toLowerCase() === this.invoiceItemGroupType.toLowerCase();
  }

  getSortedInvoiceGroups(): any[] {
    if (!Array.isArray(this.data?.InvoiceGroups)) {
      return [];
    }

    return [...this.data.InvoiceGroups].sort((left: any, right: any) => {
      return this.getInvoiceGroupSortOrder(left) - this.getInvoiceGroupSortOrder(right);
    });
  }

  shouldShowHourlyRateDetails(group: any): boolean {
    if (!this.data?.IsRot && !this.data?.IsRut) {
      return false;
    }

    if (!this.data?.IsRut) {
      return true;
    }

    if (!this.hasWorkedHoursGroup()) {
      return true;
    }

    return this.isWorkedHoursGroup(group);
  }

  private hasWorkedHoursGroup(): boolean {
    return Array.isArray(this.data?.InvoiceGroups)
      && this.data.InvoiceGroups.some((group: any) => this.isWorkedHoursGroup(group));
  }

  private getInvoiceGroupSortOrder(group: any): number {
    if (this.isInvoiceItemGroup(group)) {
      return 0;
    }

    if (this.isWorkedHoursGroup(group)) {
      return 1;
    }

    return 2;
  }

  private getGroupTotalMinutes(group: any): number {
    if (!group || !Array.isArray(group.InvoiceRows) || group.InvoiceRows.length === 0) {
      return 0;
    }

    let totalMinutes = 0;
    for (let i = 0; i < group.InvoiceRows.length; i++) {
      const row = group.InvoiceRows[i] || {};
      const hours = parseInt(row.HoursWorked, 10) || 0;
      const minutes = parseInt(row.MinutesWorked, 10) || 0;
      totalMinutes += hours * 60 + minutes;
    }

    return totalMinutes;
  }

  private getAverageHourlyRateAmount(group: any): number {
    if (this.data?.IsRut && this.hasWorkedHoursGroup() && this.isWorkedHoursGroup(group)) {
      const invoiceItemGroupsAmountTotal = this.getInvoiceItemGroupsAmountTotal();
      if (invoiceItemGroupsAmountTotal > 0) {
        return invoiceItemGroupsAmountTotal;
      }
    }

    return typeof group?.Amount === 'number' ? group.Amount : parseFloat(group?.Amount) || 0;
  }

  private getInvoiceItemGroupsAmountTotal(): number {
    if (!Array.isArray(this.data?.InvoiceGroups)) {
      return 0;
    }

    let totalAmount = 0;
    for (const group of this.data.InvoiceGroups) {
      if (!this.isInvoiceItemGroup(group)) {
        continue;
      }

      totalAmount += typeof group?.Amount === 'number' ? group.Amount : parseFloat(group?.Amount) || 0;
    }

    return totalAmount;
  }

  hasTimeRows(group: any): boolean {
    if (!group || !Array.isArray(group.InvoiceRows)) {
      return false;
    }

    return group.InvoiceRows.some((row: any) => {
      if (!row) {
        return false;
      }

      const hasStartDate = row.StartDate != null && String(row.StartDate).trim() !== '';
      const hasHours = (parseInt(row.HoursWorked, 10) || 0) > 0;
      const hasMinutes = (parseInt(row.MinutesWorked, 10) || 0) > 0;
      return hasStartDate || hasHours || hasMinutes;
    });
  }

  shouldShowTimeReportStatus(group: any): boolean {
    return this.hasTimeRows(group) && !!group?.TimeReportStatus?.DisplayName;
  }

  getInvoiceGroupTypeLabel(group: any): string {
    if (!this.hasInvoiceGroupType(group)) {
      return '';
    }

    const typeName = typeof group?.Type?.Name === 'string' ? group.Type.Name.trim() : '';
    if (typeName !== '') {
      return typeName;
    }

    return group.Type.TechnicalName;
  }

  ngOnInit() {
    if (this.data?.invoiceId) {
      this.invoiceService.getInvoice(this.data.invoiceId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: invoice => {
            this.data = invoice;
            this.initializeInvoice();
          },
          error: () => {
            this.loadError = true;
            this.setLoading(false);
            this.changeDetectorRef.markForCheck();
          }
        });
      return;
    }

    this.initializeInvoice();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private initializeInvoice(): void {
    this.dataLoaded();
    this.calculateSumAllowances();

    if (this.data.ExpressPayOut) {
      this.checkReferenceEmail(this.data.Reference.Email);
    }
    this.invoiceReady = true;
    this.changeDetectorRef.markForCheck();
  }

  dataLoaded() {
    this.hasActiveWageGarnishment = this.getHasActiveWageGarnishment();
    this.normalizeDeductionGarnishableValues();
    this.normalizeAllowanceGarnishableValues();

    this.setInitialDeductionStatus();
    this.setInitialAllowanceStatus();
    
    if (this.data.InvoiceDocument == null) {
      this.data.InvoiceDocument = { Guid: null, Url: null };
    }

    this.loadFileTypes();

    if (this.data.Organization != null && this.data.Organization.Id > 0) {
      this.organizationSender = true;
    }

    this.setLoading(false);
  }

  private getReferenceDate(): Date {
    return this.toDateOnly(this.data?.PayoutDate ?? new Date());
  }

  private toDateOnly(value: any): Date {
    const date = new Date(value);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  private getHasActiveWageGarnishment(): boolean {
    const attachments = this.data?.UserSettings?.AttachmentOfSalaries;
    if (!Array.isArray(attachments) || attachments.length === 0) {
      return false;
    }

    const referenceDate = this.getReferenceDate();
    return attachments.some((attachment: any) => {
      if (!attachment?.DateStart || !attachment?.DateEnd) {
        return false;
      }

      const startDate = this.toDateOnly(attachment.DateStart);
      const endDate = this.toDateOnly(attachment.DateEnd);
      return startDate <= referenceDate && endDate >= referenceDate;
    });
  }

  private getAllDeductions(): any[] {
    const deductions: any[] = [];

    if (Array.isArray(this.data?.Deductions)) {
      deductions.push(...this.data.Deductions);
    }

    if (Array.isArray(this.data?.InvoiceGroups)) {
      for (const group of this.data.InvoiceGroups) {
        if (Array.isArray(group?.Deductions)) {
          deductions.push(...group.Deductions);
        }
      }
    }

    return deductions.filter((d: any) => !!d);
  }

  private getAllAllowances(): any[] {
    const allowances: any[] = [];

    if (Array.isArray(this.data?.Allowances)) {
      allowances.push(...this.data.Allowances);
    }

    if (Array.isArray(this.data?.InvoiceGroups)) {
      for (const group of this.data.InvoiceGroups) {
        if (Array.isArray(group?.Allowances)) {
          allowances.push(...group.Allowances);
        }
      }
    }

    return allowances.filter((a: any) => !!a);
  }

  private normalizeDeductionGarnishableValues(): void {
    const deductions = this.getAllDeductions();
    for (const deduction of deductions) {
      if (deduction.IsGarnishable === undefined) {
        deduction.IsGarnishable = null;
      }
    }
  }

  private normalizeAllowanceGarnishableValues(): void {
    const allowances = this.getAllAllowances();
    for (const allowance of allowances) {
      if (allowance.IsGarnishable === undefined) {
        allowance.IsGarnishable = null;
      }
    }
  }

  private hasUnhandledDeductionReview(): boolean {
    if (this.data?.ParentInvoice) {
      return false;
    }

    return this.getAllDeductions().some(deduction => !deduction.ApprovedByAdmin && !deduction.DeniedByAdmin);
  }

  private hasUnhandledGarnishmentDecisions(): boolean {
    if (this.data?.ParentInvoice || !this.hasActiveWageGarnishment) {
      return false;
    }

    const hasUnhandledDeductions = this.getAllDeductions()
      .some(deduction => deduction.IsGarnishable === null || deduction.IsGarnishable === undefined);
    const hasUnhandledAllowances = this.getAllAllowances()
      .some(allowance => allowance.IsGarnishable === null || allowance.IsGarnishable === undefined);

    return hasUnhandledDeductions || hasUnhandledAllowances;
  }

  private updateUnhandledDeductionsState(): void {
    const hasUnhandledReview = this.hasUnhandledDeductionReview();
    const hasUnhandledGarnishment = this.hasUnhandledGarnishmentDecisions();

    this.hasUnhandledGarnishableDeductions = hasUnhandledGarnishment;
    this.UnhandledDeductions = hasUnhandledReview || hasUnhandledGarnishment;

    if (this.data) {
      this.data.HasUnhandledDeductions = this.UnhandledDeductions;
    }
  }

  private validateGarnishmentDeductionHandling(): boolean {
    this.updateUnhandledDeductionsState();

    if (!this.hasActiveWageGarnishment) {
      return true;
    }

    if (!this.hasUnhandledGarnishableDeductions) {
      return true;
    }

    this.invoiceService.showMessage('Det finns avdrag eller reseersattningar utan beslut om utmatningsbarhet. Valj Utmatningsbar eller Ej utmatningsbar for samtliga.');
    return false;
  }


  addLinebreaks(maxLineLength: number, text: string) {

    if (text != null) {
      var lines = text.split('\n');
      var buffer = "";

      for (var i = 0; i < lines.length; i++) {
        // If current word makes the line line longer than x, add new line
        if (lines[i].length > maxLineLength) {
          buffer += this.addLinebreak(maxLineLength, lines[i]);
        }
        else {
          buffer += lines[i] + "\n";
        }
      }
    }

    return buffer;
  }

  addLinebreak(maxLineLength: number, text: string) {

    var wordList = text.split(' ');
    var currentLine = "";
    var buffer = "";

    for (var i = 0; i < wordList.length; i++) {
      // If current word makes the line line longer than x, add new line
      if ((wordList[i].length + currentLine.length + 1) > maxLineLength) {
        buffer += currentLine;
        buffer += "\n";

        currentLine = wordList[i] + " ";
      }
      else {
        currentLine += wordList[i] + " ";
      }
    }

    // Flush the current line if not empty
    if (currentLine != "")
      buffer += currentLine + "\n";

    return buffer;
  }

  sendNotificationToUser(file: IFile, invoiceId: number) {
    var question = "";

    //if (file.FileType.TechnicalName == "CashInvoice" || file.FileType.TechnicalName == "ExpressInquiry") {
    if (file.FileType != null && (file.FileType.Id == 807 || file.FileType.Id == 304 || file.FileType.Id == 4689)) {
      question = 'Vill du skicka epost till fakturaavsändaren med filen ';
    }
    else {
      question = 'Vill du skicka epost till fakturamottagaren med filen ';
    }

    if (confirm(question + file.Name + '?')) {
      const fileGuid = file?.Guid;
      if (!fileGuid) {
        return;
      }

      const previousInvoiceNumber = this.data?.InvoiceNumber;
      const previousInvoiceDocument = this.data?.InvoiceDocument
        ? { ...this.data.InvoiceDocument }
        : null;

      this.setLoading(true);
      this.invoiceService.updateInvoiceSummary(this.data, false, false)
        .pipe(
          switchMap((updatedInvoice: any) => {
            if (updatedInvoice) {
              this.data = updatedInvoice;
              this.restoreCriticalInvoiceFieldsFromPrevious(previousInvoiceNumber, previousInvoiceDocument);
            }
            return this.invoiceService.sendFileUploadedNotification(invoiceId, fileGuid);
          }),
          switchMap(() => this.invoiceService.getInvoiceAdminView(invoiceId)),
          finalize(() => this.setLoading(false))
        )
        .subscribe(
          response => this.notificationSent(response),
          error => console.log(error));
    }
  }

  documentTypeOnChange(doc: IFile, selectedFileTypeId: number) {
    if (!doc || !doc.Guid || !selectedFileTypeId) {
      return;
    }

    const previousFileType = doc.FileType ? { ...doc.FileType } : null;

    if (!doc.FileType) {
      doc.FileType = {} as IFileType;
    }

    doc.FileType.Id = selectedFileTypeId;

    this.setLoading(true);
    this.invoiceService.updateDocumentTypeStatus(this.data.Id, doc.Guid, selectedFileTypeId)
      .subscribe(
        response => {
          const selected = this.fileTypes.find(t => t.Id == selectedFileTypeId);
          if (selected) {
            doc.FileType = { ...selected };
          }
          this.setLoading(false);
        },
        error => {
          if (previousFileType) {
            doc.FileType = previousFileType;
          }
          console.log(error);
          this.setLoading(false);
        });
  }

  notificationSent(response: any) {
    this.data = response;
    this.isInvoiceSent = true;
    this.setLoading(false);
  }

  clearInvoiceDocument() {
    if (!this.data) {
      return;
    }

    if (!this.data.InvoiceDocument) {
      this.data.InvoiceDocument = { Guid: null, Url: null };
      return;
    }

    this.data.InvoiceDocument.Guid = null;
    this.data.InvoiceDocument.Url = null;
    this.data.InvoiceDocument.Name = null;
    this.isInvoiceSent = false;
  }

  toFormattedDate(iso: string) {

    const date = new Date(iso);

    var d = `${date.getFullYear()}-${(date.getMonth() + 1).toString().length == 1 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1}-${date.getDate().toString().length == 1 ? ("0" + date.getDate().toString()) : date.getDate().toString()}`;

    if (d == '1970-01-01')
      return undefined;

    return d;
  }

  showFile(file: IFile) {
    this.fileService.openFile(file);
  }

  onDataChange(newdate) {

    //const _ = moment();
    //const date = moment(newdate).add({ hours: _.hour(), minutes: _.minute(), seconds: _.second() })
    //this.date = date.toDate();
    //console.log({ hours: _.hour(), minutes: _.minute(), seconds: _.second() })
  }

  onDateChange(evt: any) {
    console.log(evt);

    //var d = this.datePipe.transform(evt.value, "yyyy-MM-dd");

  }

  setDate(date: any) {
    this.data.InvoiceSentByUser = date;
  }

  checkReferenceEmail(email: string) {
    console.log("Test");
    const freeEmailDomains = [
      'gmail.com',
      'hotmail.com',
      'hotmail.se',
      'outlook.com',
      'yahoo.com',
      'live.com',
      'icloud.com',
      'aol.com',
      'protonmail.com',
      'msn.com',
      'yandex.com',
      'zoho.com',
      'mail.com',
      'gmx.com'
    ];

    if (!email || email.indexOf('@') === -1) {
      this.ContactEmailApprovedForExpress = false;
      return;
    }

    const domain = email.split('@')[1].toLowerCase();
    this.ContactEmailApprovedForExpress = !freeEmailDomains.includes(domain);
  }

  sendValidates(data: any): boolean {
    if (this.isLoading) return false;
    if (!data) return false;
    if (data.RecieverEmail == null || data.RecieverEmail === '') return false;
    if (!this.hasInvoiceNumber(data)) return false;
    if (!this.hasInvoiceDocument(data)) return false;
    if (data.Status.TechnicalName === 'OfferingRequested') return false;

    // Manual null check for data.Type before accessing TechnicalName
    if (data.Type && (
      data.Type.TechnicalName === 'ProformaSubInvoice' ||
      data.Type.TechnicalName === 'ProformaSingleInvoice'
    )) {
      return false;
    }

    return true;
  }

  canSaveAndClose(invoice: any): boolean {
    if (this.isLoading || !invoice) {
      return false;
    }

    const statusTechnicalName = invoice?.Status?.TechnicalName;
    const salarySharesCount = Array.isArray(invoice?.SalaryShares) ? invoice.SalaryShares.length : 0;
    const requiresUnderReviewStatus = !!invoice?.ParentInvoice || salarySharesCount > 0;
    const hasAllowedStatus = requiresUnderReviewStatus
      ? statusTechnicalName === 'UnderReview' || this.isInvoiceSent
      : statusTechnicalName === 'UnderReview' || statusTechnicalName === 'Paired';

    return hasAllowedStatus && this.hasInvoiceNumber(invoice) && this.hasInvoiceDocument(invoice);
  }

  private hasInvoiceNumber(invoice: any): boolean {
    const invoiceNumber = invoice?.InvoiceNumber;

    if (typeof invoiceNumber === 'string') {
      return invoiceNumber.trim().length > 0;
    }

    return invoiceNumber != null;
  }

  private hasInvoiceDocument(invoice: any): boolean {
    const invoiceDocument = invoice?.InvoiceDocument;

    if (!invoiceDocument) {
      return false;
    }

    const hasGuid = invoiceDocument.Guid != null && invoiceDocument.Guid !== '';
    const hasUrl = invoiceDocument.Url != null && invoiceDocument.Url !== '';
    return hasGuid || hasUrl;
  }



  rowTypeChange(event: any) {
    this.data.invoiceItemGroup.Type = this.getRowType(event.value);

    if (event.value == "Övrigt") {
      // No rows allowed in the misc category
      this.data.invoiceItemGroup.InvoiceRows = [];
    }
  }

  save(invoice: any) {
    this.setLoading(true);
    this.invoiceService.updateInvoiceSummary(invoice, false, false)
      .pipe(finalize(() => this.setLoading(false)))
      .subscribe(
        response => this.onSaved(response),
        error => console.log(error));
  }

  saveAndClose(invoice: any): void {
    if (!this.validateGarnishmentDeductionHandling()) {
      return;
    }

    const isUnderReviewInvoice = invoice?.Status?.TechnicalName === 'UnderReview';
    const isCreditPairedInvoice = invoice?.Status?.TechnicalName === 'Paired' && !!invoice?.CreditInvoiceFor;

    // Check if document is not sent for invoices under review,
    // and for credit invoices in paired (kvittad) status.
    if ((isUnderReviewInvoice || isCreditPairedInvoice) && !this.isInvoiceSent) {
      const confirmSave = window.confirm('Du har inte skickat fakturadokumentet, vill du spara ändå?');

      if (!confirmSave) {
        this.setLoading(false);  // Reset loading if user cancels
        return;  // Exit the function if the user chooses "Nej"
      }
    }

    // If the user confirmed or the conditions aren't met, proceed with the save
    this.performSaveAndClose(invoice);
  }

  performSaveAndClose(invoice: any): void {
    if (!this.validateGarnishmentDeductionHandling()) {
      return;
    }

    this.setLoading(true);
    this.invoiceService.updateInvoiceSummary(invoice)
      .subscribe(
        response => this.onSavedClosed(response),
        error => {
          console.log(error);
          this.setLoading(false);  // Reset loading on error
        });
  }

  onSavedClosed(response: any): void {
    this.dialogRef.close(this.data);
  }

  close(invoice: any) {
    this.dialogRef.close(this.data);
  }

  onSaved(response: any) {
    this.setLoading(false);

    try {
      if (response && typeof response === 'object') {
        this.data = response;
      }

      this.dataLoaded();
    } catch (error) {
      console.log(error);
      this.setLoading(false);
    }

  }

  calculateSumAllowances() {
    // Reset totals before recalculation
    this.sumMileage = 0;
    this.mileageDistance = 0;
    this.sumDomesticAllowance = 0;
    this.sumInternationalAllowance = 0;

    if (!this.data || !this.data.Allowances) { return; }

    // Only count approved allowances in all totals
    // Sum mileage
    for (let i = 0; i < this.data.Allowances.length; i++) {
      const a = this.data.Allowances[i];
      if (!a || a.ApprovedByAdmin !== true) { continue; }
      if (a.AllowanceType && a.AllowanceType.Id == 1) {
        const billed = (a.AddedToInvoice === true && a.ReimbursementPerKm && a.ReimbursementPerKm > 0 && a.sumReimbursementPerKm)
          ? a.sumReimbursementPerKm
          : a.Sum;
        this.sumMileage += Math.round((billed || 0) * 100) / 100;
        this.mileageDistance += a.Mileage || 0;
      }
    }
    this.sumMileage = Math.round(this.sumMileage * 100) / 100;

    // Sum allowance domestic travel (type 2)
    for (let i = 0; i < this.data.Allowances.length; i++) {
      const a = this.data.Allowances[i];
      if (!a || a.ApprovedByAdmin !== true) { continue; }
      if (a.AllowanceType && a.AllowanceType.Id == 2) {
        this.sumDomesticAllowance += Math.round((a.Sum || 0) * 100) / 100;
      }
    }
    this.sumDomesticAllowance = Math.round(this.sumDomesticAllowance * 100) / 100;

    // Sum allowance international travel (type 3)
    for (let i = 0; i < this.data.Allowances.length; i++) {
      const a = this.data.Allowances[i];
      if (!a || a.ApprovedByAdmin !== true) { continue; }
      if (a.AllowanceType && a.AllowanceType.Id == 3) {
        this.sumInternationalAllowance += Math.round((a.Sum || 0) * 100) / 100;
      }
    }
    this.sumInternationalAllowance = Math.round(this.sumInternationalAllowance * 100) / 100;

  }

  // Ensure totals include re-invoiced deductions for parent invoices
  private updateTotalsForParentReinvoiced(): void {
    try {
      if (!this.data || !this.data.ParentInvoice) { return; }
      let delta = 0;
      if (this.data.InvoiceGroups && this.data.InvoiceGroups.length > 0) {
        for (let g of this.data.InvoiceGroups) {
          if (g && g.Deductions && g.Deductions.length > 0) {
            for (let d of g.Deductions) {
              if (d && d.AddedToInvoice === true && typeof d.Amount === 'number') {
                delta += d.Amount;
              }
            }
          }
        }
      }
      // Only adjust if delta isn't already reflected in the total (avoid double add):
      // Heuristic: if TotalInvoiceAmount is less than sum of group base amounts + delta
      let groupsBase = 0;
      if (this.data.InvoiceGroups) {
        for (let g of this.data.InvoiceGroups) {
          groupsBase += (g && typeof g.Amount === 'number') ? g.Amount : 0;
        }
      }
      if (typeof this.data.TotalInvoiceAmount === 'number' && this.data.TotalInvoiceAmount < (groupsBase + delta)) {
        this.data.TotalInvoiceAmount = Math.round((groupsBase + delta) * 100) / 100;
      }
    } catch { /* noop */ }
  }

  changeValueInactive(value) {
    this.data.Inactive = value.checked;
  }

  setInitialDeductionStatus() {
    this.data.DeductionsTotalAmount = 0;
    this.UnhandledDeductions = false;

    if (this.data.Deductions !== undefined) {

      this.data.Deductions.forEach(deduction => {
        // Accumulate total amount
        this.calculateDeductionTotalAmount();

        // Set deduction status based on existing properties
        if (deduction.DeniedByAdmin) {
          deduction.status = 'denied';
        }
        else if (deduction.ApprovedByAdmin) {
          deduction.status = 'approved';
        }
        else {
          // Assuming both false represents 'Under Review'
          deduction.status = 'underReview';
        }
      });
    }

    if (this.data.InvoiceGroups) {
      this.data.InvoiceGroups.forEach(group => {

        if (group.Deductions !== undefined) {
          group.Deductions.forEach(deduction => {
            // Accumulate total amount
            //this.calculateDeductionTotalAmount();

            // Set deduction status based on existing properties
            if (deduction.DeniedByAdmin) {
              deduction.status = 'denied';
            }
            else if (deduction.ApprovedByAdmin) {
              deduction.status = 'approved';
            }
            else {
              // Assuming both false represents 'Under Review'
              deduction.status = 'underReview';
            }
          });
        }
      });
    }

    this.updateUnhandledDeductionsState();
  }

  calculateDeductionTotalAmount() {
    this.data.DeductionsTotalAmount = 0;
    this.DeductionsTotal = 0;

    if (this.data.Deductions != undefined) {
      for (var i = 0; i < this.data.Deductions.length; i++) {

        var deduction = this.data.Deductions[i]

        this.data.DeductionsTotalAmount += deduction.Amount;

        if (deduction.ApprovedByAdmin == true) {
          this.DeductionsTotal += deduction.Amount;
        }
      }
    }
  }

  changeDeductionStatus(deduction: any, status: string) {
    // Reset flags
    deduction.DeniedByAdmin = false;
    deduction.ApprovedByAdmin = false;

    switch (status) {
      case 'denied':
        deduction.DeniedByAdmin = true;
        break;
      case 'approved':
        deduction.ApprovedByAdmin = true;
        break;
      case 'underReview':
        // Both are false for 'Under Review'
        break;
    }

    this.updateUnhandledDeductionsState();
  }

  changeDeductionGarnishableStatus(deduction: any, isGarnishable: boolean) {
    deduction.IsGarnishable = isGarnishable;
    this.updateUnhandledDeductionsState();
  }

  setInitialAllowanceStatus() {
    try {
      if (!this.data) { return; }

      // Top-level allowances
      if (!this.data.ParentInvoice && this.data.Allowances !== undefined) {
        this.data.Allowances.forEach((allowance: any) => {
          if (allowance.DeniedByAdmin) {
            allowance.status = 'denied';
          }
          else if (allowance.ApprovedByAdmin) {
            allowance.status = 'approved';
          }
          else {
            allowance.status = 'underReview';
          }
        });
      }

      // Allowances inside groups for parent invoices
      if (this.data.ParentInvoice && this.data.InvoiceGroups) {
        this.data.InvoiceGroups.forEach((group: any) => {
          if (group.Allowances !== undefined) {
            group.Allowances.forEach((allowance: any) => {
              if (allowance.DeniedByAdmin) {
                allowance.status = 'denied';
              }
              else if (allowance.ApprovedByAdmin) {
                allowance.status = 'approved';
              }
              else {
                allowance.status = 'underReview';
              }
            });
          }
        });
      }
    } catch { /* noop */ }
  }

  changeAllowanceStatus(allowance: any, status: string) {
    // Reset flags
    allowance.DeniedByAdmin = false;
    allowance.ApprovedByAdmin = false;

    switch (status) {
      case 'denied':
        allowance.DeniedByAdmin = true;
        break;
      case 'approved':
        allowance.ApprovedByAdmin = true;
        break;
      case 'underReview':
        // both remain false
        break;
    }

    // Recalculate totals when an allowance status changes
    this.calculateSumAllowances();
    this.updateUnhandledDeductionsState();
  }

  changeAllowanceGarnishableStatus(allowance: any, isGarnishable: boolean) {
    allowance.IsGarnishable = isGarnishable;
    this.updateUnhandledDeductionsState();
  }

  approveAllAllowances() {
    try {
      if (!this.data) { return; }

      // Top-level allowances
      if (this.data.Allowances && this.data.Allowances.length > 0) {
        for (const a of this.data.Allowances) {
          if (!a) { continue; }
          a.status = 'approved';
          a.ApprovedByAdmin = true;
          a.DeniedByAdmin = false;
        }
      }

      // Group allowances (for parent/sub invoices)
      if (this.data.InvoiceGroups && this.data.InvoiceGroups.length > 0) {
        for (const g of this.data.InvoiceGroups) {
          if (!g || !g.Allowances) { continue; }
          for (const a of g.Allowances) {
            if (!a) { continue; }
            a.status = 'approved';
            a.ApprovedByAdmin = true;
            a.DeniedByAdmin = false;
          }
        }
      }

      this.calculateSumAllowances();
    } catch { /* noop */ }
  }



  getRowType(id: any) {
    for (var i = 0; i < this.rowTypeList.length; i++) {
      if (this.rowTypeList[i].Name == id) {
        return this.rowTypeList[i];
      }
    }
  }

  getGroupTotalHours(group: any) {
    var totalMinutes = 0;

    for (var i = 0; i < group.InvoiceRows.length; i++) {
      totalMinutes += parseInt(group.InvoiceRows[i].HoursWorked) * 60;
      totalMinutes += parseInt(group.InvoiceRows[i].MinutesWorked);
    }

    return this.time_convert(totalMinutes);
  }

  printAllowances() {
    alert();
  }

  time_convert(num) {
    var hours = Math.floor(num / 60);
    var minutes = num % 60;

    if (minutes > 0) {
      return hours + " h " + minutes + " min";
    }
    else {
      return hours + " h";
    }

  }

  uploadFile(event: any, file: any, fileTypeName: string = "") {
    if (event.target.files.length > 0) {

      let fileList: FileList = event.target.files;
      let f: File = fileList[0];
      file.Guid = this.newGuid();
      file.Url = null;

      this.invoiceService.uploadDocument(f, file.Guid, fileTypeName)
        .subscribe(
          response => this.fileUploaded(response, file),
          error => this.fileUploadError(error, file));

    }
  }

  fileUploaded(response: any, file: any) {
    file.Guid = response.Guid;
    file.Url = response.Url;
    file.FileType = response.FileType;
    file.Name = response.Name;

    const previousInvoiceNumber = this.data?.InvoiceNumber;
    const previousInvoiceDocument = this.data?.InvoiceDocument
      ? { ...this.data.InvoiceDocument }
      : null;

    this.setLoading(true);
    this.invoiceService.updateInvoiceSummary(this.data, false, false)
      .pipe(finalize(() => this.setLoading(false)))
      .subscribe(
        response => {
          if (response && typeof response === 'object') {
            this.data = response;
            this.restoreCriticalInvoiceFieldsFromPrevious(previousInvoiceNumber, previousInvoiceDocument);
          }

          this.dataLoaded();
        },
        error => console.log(error));
  }

  fileUploadError(error: any, file: any) {
    file.Guid = null;
    alert('Ett fel inträffade, försök igen!');
  }

  loadFileTypes() {

    this.fileTypes = [];

    this.fileTypes.push(
      { Id: 304, Name: "Expressförfrågan", TechnicalName: "ExpressInquiry" } as IFileType,
      { Id: 15, Name: "Påminnelse 1", TechnicalName: "Reminder1" } as IFileType,
      { Id: 16, Name: "Påminnelse 2", TechnicalName: "Reminder2" } as IFileType,
      { Id: 17, Name: "Skickad till inkasso", TechnicalName: "SentToInkasso" } as IFileType,
      { Id: 4689, Name: "Offert", TechnicalName: "Offering" } as IFileType
    );

    if (this.data.ParentInvoice) {
      this.fileTypes.push(
        { Id: 803, Name: "Kontantfaktura", TechnicalName: "CashInvoice" } as IFileType
      );
    }

    //this.fileService.getFileTypes()
    //  .subscribe(value => this.fileTypesLoaded(value),
    //    error => console.log(error)
    //  );
  }

  fileTypesLoaded(fileTypes: any) {
    this.fileTypes = fileTypes;
  }

  saveDocument() {

    var document = {
      FileId: this.file.Id,
      FileTypeId: this.file.FileType.Id,
      EmploymentNumber: this.data.UserSettings.EmploymentNumber,
      FileName: this.file.Name,
      DisplayDate: Date.now()
    };

    this.userService.addFile(document)
      .subscribe(
        response => this.onDocumentCreated(response),
        error => console.log(error));

    this.data.Documents.push(document);

    this.getDocuments();

    //Empty fields
    this.file.FileType.Id = null;
    this.file.Name = null;
    this.file.Name = null;
    this.file.DisplayDate = null;

  }

  uploadDocument(event: any, documentList: any) {

    // Created new file placeholder
    let file = {
      FileType: {} as IFileType
    } as IFile;
    // Give it an id
    file.Guid = this.newGuid();


    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let f: File = fileList[0];
      file.Name = f.name;

      this.invoiceService.uploadDocument(f, file.Guid)
        .subscribe(
          response => this.onDocumentSaved(response, file),
          error => console.log(error));
    }
  }

  onDocumentSaved(response: any, file: IFile) {
    file.Id = response.Id;
    file.Guid = response.Guid;
    file.Url = response.Url;
    if (response.FileType) {
      file.FileType = response.FileType;
    }

    this.invoiceService.attachDocumentToInvoice(this.data.Id, file.Guid)
      .subscribe(
        () => {
          setTimeout(() => {
            if (!this.data.Documents) {
              this.data.Documents = [];
            }
            this.data.Documents.push(file);
            this.changeDetectorRef.detectChanges();
          });
        },
        error => console.log(error));
  }

  onDocumentCreated(response: any) {

    this.file.Id = null;
    this.file.Url = null;
    this.file.Guid = null;

    this.getDocuments();
  }

  getDocuments() {
    var filter = {
      Skip: 0,
      Take: 100,
      Filter: this.filter != null ? this.filter : '',
      OrderBy: this.orderBy,
      Asc: this.asc
    };

    this.fileService.getDocuments(filter)
      .subscribe(response => this.documentsLoaded(response),
        error => console.log(error));
  }

  documentsLoaded(response: any) {

    this.documents = response.Items;
    this.dataSource = new MatTableDataSource(this.documents);
  }

  deleteDocumentFromList(file: IFile, documentList: Array<IFile>) {

    if (confirm("Vill du radera filen " + file.Name + " ?")) {
      for (var i = 0; i < documentList.length; i++) {
        if (documentList[i].Guid == file.Guid) {
          documentList.splice(i, 1);
        }
      }
    }
  }

  saveCalendar() {
    this.dialogRef.close(this.data.invoiceItemGroup);
  }

  saveRow() {
    this.dialogRef.close(this.data.invoiceItemGroup);
  }

  deleteRow() {
    this.data.invoiceItemGroup.action = 'delete';
    this.dialogRef.close(this.data.invoiceItemGroup);
  }

  cancel() {
    this.dialogRef.close(undefined);
  }

  deleteListItem(item: any) {
    this.data.invoiceItemGroup.InvoiceRows.splice(this.data.invoiceItemGroup.InvoiceRows.indexOf(item), 1);
  }

  guid() {
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }

  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  calendarSelect(event: any) {
    var date = event.toLocaleDateString();
    this.data.invoiceItemGroup.InvoiceRows.push({ StartDate: date, Id: this.guid(), HoursWorked: this.hoursSelected, Vat: this.vatSelected });
  }

  onError(error: any) {
    alert('An error occured');
    console.log(error);
  }

  showDocument(file: IFile) {
    this.fileService.openFile(file);
  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  downloadTravelReport(invoiceNumber) {

    if (this.downloading) return;
    this.downloading = true;
    this.activePdfReport = 'travel';
    this.completedPdfReport = null;

    var invoice = invoice;

    this.invoiceService.getOverviewdReport(this.data.Id)
      .pipe(finalize(() => {
        this.downloading = false;
        this.activePdfReport = null;
        this.changeDetectorRef.markForCheck();
      }))
      .subscribe(x => {
        try {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([x], { type: "application/pdf" });

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveOrOpenBlob(newBlob);
            this.completedPdfReport = 'travel';
            return;
          }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);

          var link = document.createElement('a');
          link.href = data;

          //link.download = "travelReport.pdf";
          link.download = invoiceNumber + ".pdf";

          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          this.completedPdfReport = 'travel';

          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();

          }, 100);
        } finally {
          this.downloading = false;
        }
      }, error => {
        this.downloading = false;
        this.onError(error);
      });

  }

  downloadParentInvoiceInfoReport(invoiceNumber) {

    if (this.downloading) return;
    this.downloading = true;
    this.activePdfReport = 'parent';
    this.completedPdfReport = null;

    this.invoiceService.ParentInvoiceInfo(this.data.Id)
      .pipe(finalize(() => {
        this.downloading = false;
        this.activePdfReport = null;
        this.changeDetectorRef.markForCheck();
      }))
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x], { type: "application/pdf" });

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(newBlob);
          this.completedPdfReport = 'parent';
          return;
        }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        var link = document.createElement('a');
        link.href = data;

        var fileName = "ParentInvoiceId_" + this.data.Id;

        //link.download = "travelReport.pdf";
        link.download = fileName + ".pdf";

        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        this.completedPdfReport = 'parent';

        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();

        }, 100);
      }, error => this.onError(error));

  }


  downloadDeductionsReport(invoiceNumber) {

    if (this.downloading) return;
    this.downloading = true;
    this.activePdfReport = 'deductions';
    this.completedPdfReport = null;

    this.invoiceService.InvoicedDeductionInfo(this.data.Id)
      .pipe(finalize(() => {
        this.downloading = false;
        this.activePdfReport = null;
        this.changeDetectorRef.markForCheck();
      }))
      .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([x], { type: "application/pdf" });

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveOrOpenBlob(newBlob);
          this.completedPdfReport = 'deductions';
          return;
        }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);

        var link = document.createElement('a');
        link.href = data;

        var fileName = "ParentInvoiceId_" + this.data.Id + "_deductions";

        //link.download = "travelReport.pdf";
        link.download = fileName + ".pdf";

        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        this.completedPdfReport = 'deductions';

        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();

        }, 100);
      }, error => this.onError(error));

  }

  editCustomer(customer: any) {
    this.config.data.customer = customer;
    let dialogRef = this.dialog.open(EditCustomerDialogComponent, this.config);
    dialogRef.afterClosed().subscribe((result: ICompany) => {
      this.data.Customer = result;
      //this.updateCustomer(result);
      //this.setInvoiceEmail(result.InvoiceEmail);
      dialogRef = null;
    });
  }

  getSendTypeName(sendTypeId: number) {
    for (var i = 0; i < this.sendTypes.length; i++) {
      var sendType = this.sendTypes[i];
      if (sendTypeId == sendType.Id) {
        return sendType.Name;
      }
    }

  }

  sendDocumentByEmailValidation(type: IFileType, recieverEmail: string, referenceEmail: string, reminderEmail: string) {

    if (type != null && type.Id > 0) {
      const isExpressInquiry = type.TechnicalName === 'ExpressInquiry';
      const isReminder = type.TechnicalName === 'Reminder1' || type.TechnicalName === 'Reminder2';
      const isOffering = type.TechnicalName === 'Offering';
      const isSentToInkasso = type.TechnicalName === 'SentToInkasso';

      if (isExpressInquiry && (referenceEmail == null || referenceEmail == '')) {
        this.sendDocumentByEmailValid = false;
        this.sendDocumentByEmailErrorMessage = 'Epost till referensperson saknas';
        return false;
      }
      else if (isReminder && ((recieverEmail == null || recieverEmail == '') && (reminderEmail == null || reminderEmail == ''))) {
        this.sendDocumentByEmailValid = false;
        this.sendDocumentByEmailErrorMessage = 'Epost för fakturapåminnelse saknas';
        return false;
      }
      else if (!isExpressInquiry && !isReminder && !isOffering && (recieverEmail == null || recieverEmail == '')) {
        this.sendDocumentByEmailValid = false;
        this.sendDocumentByEmailErrorMessage = 'Epost till fakturamottagare saknas';
        return false;
      }
      else if (isSentToInkasso) {
        this.sendDocumentByEmailValid = true;
        this.sendDocumentByEmailErrorMessage = '';
        return true;
      }
      else {
        this.sendDocumentByEmailValid = true;
        this.sendDocumentByEmailErrorMessage = '';
        return true;
      }
    }
    //else {
    //  this.sendDocumentByEmailValid = true;
    //  return true;
    //}
  }

  private restoreCriticalInvoiceFieldsFromPrevious(previousInvoiceNumber: any, previousInvoiceDocument: any): void {
    if (!this.hasInvoiceNumber(this.data) && previousInvoiceNumber != null) {
      this.data.InvoiceNumber = previousInvoiceNumber;
    }

    if (!this.hasInvoiceDocument(this.data) && previousInvoiceDocument) {
      this.data.InvoiceDocument = previousInvoiceDocument;
    }
  }



  config = {
    disableClose: false,
    panelClass: 'full-screen-modal',
    hasBackdrop: true,
    backdropClass: '',
    width: '500px',
    maxWidth: '100vw',
    height: '100%',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    },
    data: {
      invoiceItemGroup: {},
      customerTemplate: {},
      customer: {},
      contact: {},
      companyId: 0,
      description: '',
      ////status: {},
      //deduction: {} as IDeduction,
      //allowance: {} as IAllowance
    },
    dataTemplate: {
      Id: 0,
      Country: { Id: 1 },
      Type: {},
      HoursWorked: undefined,
      StartDate: undefined,
      EndDate: undefined,
      Comment: undefined,
      InvoiceId: 0
    }
  };
}





